// extracted by mini-css-extract-plugin
export default {"pagination":"UsersPagination_pagination__84Dhj"};